import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=b60a4a02&"
import script from "./multiple.vue?vue&type=script&lang=js&"
export * from "./multiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b60a4a02')) {
      api.createRecord('b60a4a02', component.options)
    } else {
      api.reload('b60a4a02', component.options)
    }
    module.hot.accept("./multiple.vue?vue&type=template&id=b60a4a02&", function () {
      api.rerender('b60a4a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataEntry/components/multiple.vue"
export default component.exports